import type { Game } from '../../game/Game';
import { registerOverlay, registerPanel } from '../../ui/app/App';
import { openPanel } from '../../ui/app/store';
import { EventBanner, EventsPanel } from './EventsPanel';
import { eventNotifier, worldEventsFor } from './runtime';
import './events.css';

/**
 * World events: field bosses on a fixed schedule and hourly Aether Breaches
 * (Lost Ark's field bosses / Chaos Gates), with a calendar panel.
 */
export function install(game: Game): void {
  registerPanel('events', EventsPanel);
  registerOverlay(EventBanner);
  game.hud.addMenuButton('Events', '—', () => openPanel('events'));
  game.zoneSetups.push((g, z) => {
    const s = worldEventsFor(g, z);
    if (s) z.scripts.push(s);
  });
  game.systems.push(eventNotifier(game));
}

export { EVENTS, calendar, occurrence, relevant } from './schedule';
export { BREACH_WAVES, WorldEventScript, breachPoint } from './runtime';
